import { UPDATE_PAYMENT_ITEM_CODE_INFO } from "../../redux-flow/arsVariables";

const updatePaymentCodeInfo = payload => ({
  type: UPDATE_PAYMENT_ITEM_CODE_INFO,
  payload
});

export default updatePaymentCodeInfo;
